import React from 'react'
import PropTypes from 'prop-types'
import css from './patientCard.css'

const AccountHolders = ({ accountHolders }) => (
  <div className={css.accountHolders}>
    <div className={css.horizontalLine} />
    <span className={css.label}>
      Account Holders
    </span>
    <ul className={css.list}>
      {accountHolders.map(ah => <li className={css.accountHolder} key={ah.id}>{ah.first_name} {ah.last_name}</li>)}
    </ul>
  </div>
)

export default AccountHolders



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/AccountHolders.js